<template>
  <div class="">
    <v-row justify="center" align-content="center" class="mt-2">
      <v-col cols="12" md="6">
      </v-col>
    </v-row>

    <v-row
      class="test"
      justify="center"
      align-content="center"
      :class="{ 'mt-2': true, 'mt-4 mb-10': isMobile }"
    >
      <v-col cols="12" md="4">
        <v-card elevation="0" outlined>
          <v-card-title class="">
            <h2 :class="{ 'mx-0 px-0': isMobile }">
              {{ registering === true ? "New application" : "Login" }}
            </h2>
            <v-spacer></v-spacer>
          </v-card-title>

          <!-- <v-divider></v-divider> -->

          <v-card-text v-if="registering" justify-center class="text-center">
            <v-select
                dense
                class="mt-4"
                item-text="id"
                required
                :rules="textRules"
                outlined
                :items="admissions"
                v-model="admission"
                return-object
                placeholder="Application type"
            >
              <template v-slot:item="{ item }">
                {{ item.applicationType.name + " " + item.session.name }}
              </template>
              <template v-slot:selection="{ item }">
                {{ item.applicationType.name + " " + item.session.name }}
              </template>
            </v-select>

            <v-form v-model="dataValid" ref="form">
              <div
                v-if="
                  admission != null &&
                  admission.applicationType.autoLoadUtme === true
                "
              >
                <v-text-field
                  class="text-center mt-4"
                  outlined
                  dense
                  placeholder="UTME REG / Applicant ID"
                  v-model="jambRegNumber"
                  required
                  :rules="textRules"
                ></v-text-field>
              </div>

              <div
                v-if="
                  admission != null &&
                  admission.applicationType.modeOfEntryEnabled === true
                "
              >
                <v-select
                  class="mt-4"
                  :items="modeOfEntries"
                  item-text="title"
                  item-value="id"
                  outlined
                  dense
                  placeholder="Mode of entry"
                  v-model="obj.modeOfEntryId"
                  required
                  :rules="textRules"
                ></v-select>
              </div>

              <div>
                <v-text-field
                  class="mt-4"
                  required
                  :rules="emailRules"
                  outlined
                  dense
                  placeholder="Email address"
                  v-model="obj.emailAddress"
                ></v-text-field>
              </div>

              <div class="">
                <v-text-field
                  :type="showPassword ? 'text' : 'password'"
                  class="mt-4"
                  outlined
                  dense
                  placeholder="Password"
                  v-model="obj.password"
                  required
                  :rules="passwordRules"
                  :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                  @click:append="showPassword = !showPassword"
                ></v-text-field>
              </div>

              <v-text-field
                :type="showPassword ? 'text' : 'password'"
                class="mt-4"
                outlined
                dense
                placeholder="Confirm Password"
                v-model="obj.confirmPassword"
                required
                :rules="textRules"
              ></v-text-field>

              <div class="">
                <div
                  v-if="registering"
                  class="d-flex flex flex-wrap basic--text text-sm"
                >
                  <div>
                    Already registered?
                    <a
                      class="primary--text"
                      @click="
                        (e) => {
                          e.preventDefault();
                          this.registering = !this.registering;
                        }
                      "
                      >Login</a
                    >
                  </div>
                </div>
                <div class="d-flex mt-4">
                  <v-spacer></v-spacer>
                  <v-btn
                    class="ml-auto"
                    color="primary"
                    depressed
                    @click="submitData"
                    :disabled="
                      !dataValid || obj.password !== obj.confirmPassword || loading || admission == null
                    "
                    :loading="loading"
                    >Proceed</v-btn
                  >
                </div>
              </div>
            </v-form>
          </v-card-text>

          <!--    Login      -->
          <v-card-text v-else>
            <v-form v-model="loginValid" ref="login" tabIndex="0">
              <v-alert v-if="!registering && usingOldReg" outlined type="info">
                {{ newRegMessage }}
              </v-alert>
              <v-text-field
                class="mt-4"
                outlined
                required
                :rules="textRules"
                dense
                placeholder="Email address / Applicant ID"
                v-model="user.username"
              ></v-text-field>

              <v-text-field
                :type="showPasswordLogin ? 'text' : 'password'"
                :append-icon="showPasswordLogin ? 'mdi-eye-off' : 'mdi-eye'"
                @click:append="showPasswordLogin = !showPasswordLogin"
                class="mt-4"
                required
                :rules="textRules"
                outlined
                dense
                placeholder="Password"
                v-model="user.password"
                @keyup.enter="login"
              ></v-text-field>
              <div>
                Not registered?
                <a
                  class="primary--text"
                  @click="
                    (e) => {
                      e.preventDefault();
                      this.registering = !this.registering;
                    }
                  "
                  >Register</a
                >
                or Forgot password?
                <a class="primary--text" href="/login">click here</a> and then
                click on forgot password
              </div>
            </v-form>
            <div class="d-flex">
              <v-btn
                class="ml-auto"
                color="primary"
                depressed
                @click="login"
                :disabled="!loginValid"
                :loading="loginLoading"
                >Login</v-btn
              >
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <loading-dialog :show="loading"></loading-dialog>
    <message-box
      :show="messageShow"
      :message="message"
      :type="messageType"
      v-on:close-message="messageShow = !messageShow"
    ></message-box>
    <v-fab-transition>
      <v-btn
          :key="'support'"
          :color="'success'"
          fab
          large
          dark
          bottom
          right
          fixed
          small
          class="v-btn--example"
          tag="a"
          href="https://wa.me/2348106558581"
      >
        <v-icon>{{ 'mdi-whatsapp' }}</v-icon>
      </v-btn>
    </v-fab-transition>
  </div>
</template>

<script>
import LoadingDialog from "@ui/components/LoadingDialog";
import MessageBox from "@ui/components/MessageBox";
import Api from "@/main/api";
import ErrorResolver from "@/shared/ErrorResolver";
import ValidationRules from "@/shared/ValidationRules";
import DateUtil from "@/shared/DateUtil";
import LoginUtil from "../../../../login/LoginUtil";
import Roles from "@/shared/Roles";
export default {
  name: "Login",
  components: { MessageBox, LoadingDialog },

  data: () => ({
    obj: {},
    jambRegNumber: null,
    utmeYear: "",
    messageType: "",
    message: "",
    messageShow: false,
    loading: false,
    admissions: [],
    admission: null,
    modeOfEntries: [],
    registering: true,
    years: DateUtil.getYearsArray(2010),
    dataValid: true,
    loginValid: true,
    loginLoading: false,
    textRules: ValidationRules.textRules,
    emailRules: ValidationRules.emailRules,
    passwordRules: ValidationRules.passwordRules,
    showPassword: false,
    showPasswordLogin: false,
    user: {
      applicant: true,
    },
    usingOldReg: false,
    newRegMessage: "",
  }),

  methods: {
    getAdmissions() {
      this.loading = true;
      Api.admission
        .getActiveAdmissions()
        .then((res) => {
          this.admissions = res.data;
        })
        .catch((err) => ErrorResolver.checkErrors(this, err))
        .finally(() => (this.loading = false));
    },

    loadModeOfEntries() {
      if (this.admission != null) {
        this.modeOfEntries = [];
        Api.system
          .modeOfEntries(this.admission.session.programmeType.id)
          .then((res) => (this.modeOfEntries = res.data))
          .catch((err) => ErrorResolver.checkErrors(this, err));
      }
    },

    submitData() {
      if (
        this.admission != null &&
        this.admission.applicationType.autoLoadUtme === true
      ) {
        // validate utme first
        // validate utme
        this.loading = true;
        let vm = this;
        Api.applicants
          .validateUTME({
            registrationNumber: this.jambRegNumber,
            admissionId: this.admission.id,
          })
          .then(() => {
            this.message = "Validation successful";
            this.messageType = "success";
            this.messageShow = true;
            this.register();
          })
          .catch((err) => {
            ErrorResolver.checkErrors(vm, err);
            this.loading = false;
          });
      } else {
        // go ahead with registration
        this.register();
      }
    },

    register() {
      this.loading = true;
      this.obj.admissionId = this.admission.id;
      this.obj.jambRegNumber = this.jambRegNumber;
      Api.applicants
        .register(this.obj)
        .then(() => {
          this.message = "Registration was successful";
          this.messageType = "success";
          this.messageShow = true;
          this.registering = false;
        })
        .catch((err) => {
          ErrorResolver.checkErrors(this, err);
        })
        .finally(() => (this.loading = false));
    },

    login() {
      // input must be valid
      if (!this.loginValid) return;

      this.loginLoading = true;
      Api.auth
        .login(this.user)
        .then((res) => {
          // if using old reg no.
          if (res.data.old) {
            this.usingOldReg = true;
            this.newRegMessage =
              "Use " + res.data.applicant + " as your username to login";
            return;
          }
          // check
          if (!Roles.contains(res.data.roles, Roles.Applicant)) {
            window.location.href = "/login";
          }
          // save to cookie
          LoginUtil.setAccessToken(res.data.jwt);
          LoginUtil.setRefreshToken(res.data.refreshToken);
          this.$router.push("application");
          // reload
          window.canReload = true;
        })
        .catch((err) => {
          ErrorResolver.checkErrors(this, err);
        })
        .finally(() => {
          this.loginLoading = false;
        });
    },
  },

  computed: {
    isMobile: function () {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },

  watch: {
    admission: function (val) {
      this.$refs.form.reset()
      if (val != null && val.applicationType.modeOfEntryEnabled) {
        this.modeOfEntries = this.admission.applicationType.modeOfEntries
      }
    },
  },

  created() {
    this.getAdmissions();
  },
};
</script>

<style lang="css" scoped>
@media screen and (min-width: 320px) and (max-width: 800px) {
  h2 {
    margin-left: 15%;
    padding-bottom: 4%;
  }
  .sub {
    display: flex;
  }
}

@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
  .test {
    position: absolute;
    width: 70%;
    margin-left: 7.8rem;
  }
}

@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: landscape) {
  .test {
    width: 70%;
  }
}
</style>
